// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_49-2";
export var blackBorderOnHover = "_49-7";
export var cell = "_49-6";
export var cellContainer = "_49-3";
export var checked = "_49-8";
export var disabled = "_49-5";
export var featuredIconCellContainer = "_49-9";
export var featuredIconTextContainer = "_49-b";
export var featuredIconWrapper = "_49-a";
export var noBorder = "_49-c";
export var orangeSelectedRow = "_cu-3";
export var overflowableText = "_49-0";
export var overflowableTextContainer = "_49-1";
export var row = "_4c-0";
export var rowCheckboxCell = "_49-4";
export var selectableTable = "_cu-2";